import React, { FC } from 'react'
import styled from 'styled-components'

import { createMediaStyles } from '../../../lib/styled-helpers'

export const MoreInfoContent = () => {
  return (
    <Wrap>
      <Title>Лимиты на ремонт с учётом НДС</Title>
      <Subtitle>
        Стоимость одного ремонта должна быть до 100 000 ₽. Для автомобилей мощностью от 406 до 626 л. с. — 150 000
        ₽.Если сумма больше, разницу придётся доплатить.
      </Subtitle>
      <Subtitle>
        Общая стоимость ремонта за 6 месяцев не должна быть больше 1 000 000 ₽ для премиальных марок автомобилей и 500
        000 ₽ — для массового сегмента.
      </Subtitle>
      <Subtitle>
        Ремонт производится только на авторизованных станциях технического обслуживания партнёра Авито — ООО "Евразии
        Ассистанс".
      </Subtitle>
      <Title>Что делать при поломке</Title>
      <Subtitle>
        Позвоните по телефону 8 495 783-06-06, и вас запишут в сервисный центр на диагностику. С собой нужно взять
        гарантийный сертификат, СТС, сервисную книжку или документы о прохождении ТО.
      </Subtitle>
      <Link href="https://drive.google.com/file/d/145m4zZSu8EinjHwrjl3uoqK0-Zm3yQj8/view" target="_blank">
        <Subtitle>{`Посмотреть пример сертификата`}</Subtitle>
      </Link>
    </Wrap>
  )
}

const Wrap = styled.div`
  position: relative;
  ${({ theme }) => theme.textStyles.p1}
  line-height: 2.4rem;
  font-weight: 500;

  ${createMediaStyles(() => ({
    phone: 'padding: 26px 0 0;',
    desktop: 'padding: 26px 15px 15px;'
  }))}
`

const Title = styled.div`
  ${({ theme }) => theme.textStyles.h4};
  margin-bottom: ${({ theme }) => theme.spacing[4]};
  max-width: 75%;
  font-weight: 700;
  ${createMediaStyles(() => ({
    phone: 'line-height: 32px; font-size: 2.4rem'
  }))}
`

const Subtitle = styled.div`
  ${({ theme }) => theme.textStyles.p2};
  font-size: 16px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.black};
  margin-bottom: ${({ theme }) => theme.spacing[3]};
`

const Link = styled.a`
  color: inherit;
`
